/* Prix des articles de blog, alignes sur le catalogue en direct.
 *
 * Le script relie chaque lien "/products/<handle>" au prix affiche a cote,
 * interroge la fiche produit et corrige le montant si la boutique a change.
 *
 * Deux dispositions sont reconnues :
 *   1. le prix est DANS le lien        -> <a href="/products/x">Windows 11 Pro - des 129,90 EUR</a>
 *   2. le prix est A COTE du lien      -> <span>24,99 EUR</span> <a href="/products/x">Acheter</a>
 * La seconde est celle des encarts produits generes par Wisewand.
 *
 * Garde-fous, identiques a ceux du script de resynchronisation serveur :
 * on ne touche un prix que si son conteneur ne reference qu'un seul produit,
 * ne contient pas plus de deux prix (prix barre tolere) et reste court.
 * Un montant cite au fil d'une phrase n'est jamais reecrit.
 */
(function () {
  var racine = document.querySelector(".article-body") || document.querySelector(".article-page");
  if (!racine) return;

  var euro = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" });
  var PRIX = /\d{1,4}(?:[.,]\d{2})?[\s ]*€/;
  var PRIX_TOUS = /\d{1,4}(?:[.,]\d{2})?[\s ]*€/g;
  var NIVEAUX_MAX = 3;      // hauteur de remontee depuis le lien
  var TAILLE_ENCART = 400;  // longueur max du texte d'un encart
  var AVANT_MAX = 30;       // longueur max de ce qui precede le prix dans son bout de texte

  var cache = {};
  function fiche(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch("/products/" + handle + ".js", { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function texteDe(element) {
    return (element.textContent || "").replace(/\s+/g, " ").trim();
  }

  function produitsDe(element) {
    var vus = {};
    element.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var h = (a.getAttribute("href") || "").split("/products/")[1];
      if (h) vus[h.split(/[?#]/)[0]] = 1;
    });
    return Object.keys(vus);
  }

  /* Premier noeud de texte contenant un prix, a l'interieur de `element`.
     `hors` permet d'ignorer ce qui est deja dans le lien. */
  function noeudPrix(element, hors) {
    var marcheur = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null);
    while (marcheur.nextNode()) {
      var n = marcheur.currentNode;
      if (hors && hors.contains(n)) continue;
      var m = n.nodeValue.match(PRIX);
      if (!m) continue;
      // Une etiquette de prix se termine par le prix : "24,99 EUR", "Windows 11 Pro - des 129,90 EUR".
      // Si la phrase continue apres le montant, c'est de la prose : on ne touche pas.
      var apres = n.nodeValue.slice(m.index + m[0].length).replace(/[\s .,;:!?)\]]/g, "");
      if (apres) continue;
      if (n.nodeValue.slice(0, m.index).trim().length > AVANT_MAX) continue;
      return n;
    }
    return null;
  }

  /* Le noeud a corriger pour ce lien : dans le lien, sinon dans l'encart qui l'entoure. */
  function cible(lien) {
    var dedans = noeudPrix(lien, null);
    if (dedans) return dedans;

    var boite = lien.parentElement;
    for (var niveau = 0; niveau < NIVEAUX_MAX && boite && boite !== racine; niveau++) {
      var texte = texteDe(boite);
      if (texte.length > TAILLE_ENCART) return null;              // trop gros : c'est de la prose
      if (produitsDe(boite).length === 1 && (texte.match(PRIX_TOUS) || []).length <= 2) {
        var n = noeudPrix(boite, lien);
        if (n) return n;
      }
      boite = boite.parentElement;
    }
    return null;
  }

  racine.querySelectorAll('a[href^="/products/"], a[href^="https://sos-ordinateur.store/products/"]')
    .forEach(function (lien) {
      if (lien.dataset.prixPose) return;
      lien.dataset.prixPose = "1";

      var handle = (lien.getAttribute("href") || "").split("/products/")[1];
      if (!handle) return;
      handle = handle.split(/[?#]/)[0];

      fiche(handle).then(function (p) {
        if (!p || typeof p.price_min !== "number" || p.price_min <= 0) return;

        var attendu = euro.format(p.price_min / 100);
        var libelle = (p.price_max && p.price_max !== p.price_min ? "dès " : "") + attendu;
        var noeud = cible(lien);

        if (noeud) {
          var actuel = noeud.nodeValue.match(PRIX)[0];
          // « dès » est deja ecrit devant le montant ? on ne le redouble pas.
          if (/(?:dès|à partir de)\s*$/i.test(noeud.nodeValue.slice(0, noeud.nodeValue.indexOf(actuel)))) {
            libelle = attendu;
          }
          if (actuel.replace(/[\s ]/g, "") === attendu.replace(/[\s ]/g, "")) return;
          noeud.nodeValue = noeud.nodeValue.replace(PRIX, libelle);
          lien.setAttribute("data-prix-corrige", actuel + " -> " + libelle);
          return;
        }

        /* Aucun prix affiche : on en ajoute un, mais seulement sur les CTA prevus pour. */
        if (lien.closest("[data-inline-cta], [data-cta-fin]")) {
          var s = document.createElement("span");
          s.className = "cta-prix";
          s.textContent = libelle;
          s.setAttribute("style", "display:inline-block;margin-left:10px;color:#0a1f44;" +
            "font-weight:800;font-size:14px;white-space:nowrap;vertical-align:middle");
          lien.insertAdjacentElement("afterend", s);
        }
      });
    });
})();
